export default {
  order: 3,
  layerGroupId: 'GROUP_CLIMATE',
  dataLayer: {
    id: 'AIR_QUALITY',
    order: 3,
    type: 'remoteDataLayer',
    uuid: '67d8aed9-8eb3-4396-99a4-f0eee7295226',
    groupId: 'GROUP_CLIMATE',
  },
  layer: {
    metadata: {
      colormap: null,
      inputRange: null,
      legendConfig: {
        name: {
          en: 'Latest Months Average Tropospheric Nitrogen Dioxide (NO₂) (mol/m², millionths)',
          fr: "Moyenne des derniers mois du dioxyde d'azote troposphérique (NO₂) (mol/m², millionièmes)",
          es: 'Promedio de los últimos meses de dióxido de nitrógeno troposférico (NO₂) (mol/m², millonésimas)',
          pt: 'Meses mais recentes Dióxido de azoto troposférico médio (NO₂) (mol/m², milionésimos)',
          id: 'Rata-rata Nitrogen Dioksida (NO₂) Troposfer Bulan Terakhir (mol/m², juta-an)',
          zh: '最近几个月平均对流层二氧化氮（NO₂）（mol/m²，百万分之一）',
          ka: 'Latest Months Average Tropospheric Nitrogen Dioxide (NO₂) (mol/m², millionths)',
        },
        type: 'gradient',
        items: [
          {
            color: 'rgb(0, 0, 3)',
            name: {
              en: '≤5',
              fr: '≤5',
              es: '≤5',
              pt: '≤5',
              id: '≤5',
              zh: '≤5',
              ka: '≤5',
            },
          },
          {
            color: 'rgb(85, 15, 109)',
            name: {
              en: '10',
              fr: '10',
              es: '10',
              pt: '10',
              id: '10',
              zh: '10',
              ka: '10',
            },
          },
          {
            color: 'rgb(186, 54, 85)',
            name: {
              en: '30',
              fr: '30',
              es: '30',
              pt: '30',
              id: '30',
              zh: '30',
              ka: '30',
            },
          },
          {
            color: 'rgb(249, 140, 9)',
            name: {
              en: '100',
              fr: '100',
              es: '100',
              pt: '100',
              id: '100',
              zh: '100',
              ka: '100',
            },
          },
          {
            color: 'rgb(252, 254, 164)',
            name: {
              en: '≥300',
              fr: '≥300',
              es: '≥300',
              pt: '≥300',
              id: '≥300',
              zh: '≥300',
              ka: '≥300',
            },
          },
        ],
      },
      interactionConfig: {},
      outputRange: null,
    },
    id: 'AIR_QUALITY',
    type: 'base-tile-layer',
    url: 'https://tiles.globalforestwatch.org/tropomi_avg_nitrogen_dioxide_last_month/latest/default/{z}/{x}/{y}.png',
    technicalName: 'tropomi_nitrogen_dioxide',
    label: {
      en: 'Air Quality: Nitrogen Dioxide (NO₂) Satellite Measurements',
      fr: "Qualité de l'air : Mesures satellitaires du dioxyde d'azote (NO₂)",
      es: 'Calidad del aire: Mediciones de dióxido de nitrógeno (NO₂) por satélite',
      pt: 'Qualidade do ar: Dióxido de Azoto (NO₂) Medições por satélite',
      id: 'Kualitas Udara: Pengukuran Satelit Nitrogen Dioksida (NO₂)',
      zh: '空气质量。二氧化氮（NO₂）卫星测量',
      ka: 'Air Quality: Nitrogen Dioxide (NO₂) Satellite Measurements',
    },
    sublabel: {
      en: '3.5 x 5.5 km, global, 2018, TROPOMI/ESA/KNMI/DLR/SRON/BIRA-IASB/STFC/MPIC/S[&]T/Uni-Bremen',
      fr: '3.5 x 5.5 km, global, 2018, TROPOMI/ESA/KNMI/DLR/SRON/BIRA-IASB/STFC/MPIC/S[&]T/Uni-Bremen',
      es: '3.5 x 5.5 km, global, 2018, TROPOMI/ESA/KNMI/DLR/SRON/BIRA-IASB/STFC/MPIC/S[&]T/Uni-Bremen',
      pt: '3.5 x 5.5 km, global, 2018, TROPOMI/ESA/KNMI/DLR/SRON/BIRA-IASB/STFC/MPIC/S[&]T/Uni-Bremen',
      id: '3.5 x 5.5 km, global, 2018, TROPOMI/ESA/KNMI/DLR/SRON/BIRA-IASB/STFC/MPIC/S[&]T/Uni-Bremen',
      zh: '3.5 x 5.5 km, 全球, 2018, TROPOMI/ESA/KNMI/DLR/SRON/BIRA-IASB/STFC/MPIC/S[&]T/Uni-Bremen',
      ka: '3.5 x 5.5 km, global, 2018, TROPOMI/ESA/KNMI/DLR/SRON/BIRA-IASB/STFC/MPIC/S[&]T/Uni-Bremen',
    },
  },
  isError: false,
};
